/**
 * Convenience composition over `useMeasurementCapture` and
 * `useMeasurementAutoPopulate`. Single entry point for Report.tsx so it
 * does not need to know about the two-hook split.
 */

import type { Dispatch, SetStateAction } from 'react';
import type { notification } from 'antd';
import { Report as MReport } from '@/models/report';
import { Study } from '@/models/study';
import type { MeasurementGroup } from '@/models/template';
import { useMeasurementCapture } from './useMeasurementCapture';
import { useMeasurementAutoPopulate } from './useMeasurementAutoPopulate';

type NotificationApi = ReturnType<typeof notification.useNotification>[0];

interface UseMeasurementHydrationArgs {
  reportData: MReport | undefined;
  currentReport: MReport | null;
  // The raw useState setter — auto-populate needs the functional form.
  setCurrentReport: Dispatch<SetStateAction<MReport | null>>;
  study: Study;
  /** Worksheet groups — the AP-731 engine's scope and formula source (R3). */
  measurementGroups?: MeasurementGroup[];
  notification: NotificationApi;
}

export function useMeasurementHydration({
  reportData,
  currentReport,
  setCurrentReport,
  study,
  measurementGroups,
  notification: api,
}: UseMeasurementHydrationArgs): void {
  useMeasurementCapture({
    currentReport,
    setCurrentReport,
    measurementGroups,
    patientSex: study.patientSex,
    notification: api,
  });
  useMeasurementAutoPopulate({
    reportData,
    currentReport,
    setCurrentReport,
    study,
    measurementGroups,
  });
}
